import { ICallableRequestBuilder } from "@/api/requestBuilder/types";
import { ArtOrderReview } from "../types";
import config from "@shared/config/client";
import queryString from "query-string";
import { DEFAULT_PAGE_SIZE } from "@/shared/constants";

const getByArtistId =
  (request: ICallableRequestBuilder<ArtOrderReview[]>) =>
  async (artistId: string, page = 0, pageSize = DEFAULT_PAGE_SIZE) => {
    const query = {
      skip: page * pageSize,
      take: pageSize,
    };

    const url = queryString.stringifyUrl({
      url: `${config.apiUrl}/art-order/reviews/artist/${artistId}`,
      query,
    });

    return request.call(url);
  };

const requests = {
  getByArtistId,
};

export default requests;
